var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.user_countries.length > 1
        ? _c(
            "q-btn-dropdown",
            {
              attrs: {
                label: _vm.getCountryLabel,
                icon: "fas fa-globe",
                flat: ""
              },
              model: {
                value: _vm.show_countries,
                callback: function($$v) {
                  _vm.show_countries = $$v
                },
                expression: "show_countries"
              }
            },
            [
              _c(
                "q-list",
                { attrs: { link: "" } },
                _vm._l(_vm.user_countries, function(item, index) {
                  return _vm.id_user_client_country_selected != item.id
                    ? _c(
                        "q-item",
                        {
                          key: index,
                          nativeOn: {
                            click: function($event) {
                              return _vm.changeCountry(item)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(item.name))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }